'use client';

import React from 'react';

export default function Loading() {
  return (
    <div className="loading-container">
      <p>Đang tải nội dung, vui lòng chờ...</p>
    </div>
  );
}
